import { render, staticRenderFns } from "./MyOrganizationUnits.vue?vue&type=template&id=5c129718"
import script from "./MyOrganizationUnits.vue?vue&type=script&lang=js"
export * from "./MyOrganizationUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports